import React from 'react';

import { renderWhenTrue } from '../../utils';
import { useHeaderAnimation } from '../../utils/useHeaderAnimation';

import {
  Container,
  InnerContainer,
  Content,
  Subheader,
  Header,
  HalfBox,
  TopContentContainer,
  LocalButton,
  VideoBackground,
  HeaderContainer,
  SubHeaderContainer,
  HeadersBox,
} from './photoHeader.styled';
import { PhotoHeaderData } from './photoHeader.types';

export const PhotoHeader: React.FC<PhotoHeaderData> = (data: PhotoHeaderData) => {
  const {
    subheaderContent,
    headerContent,
    buttonLabel,
    background,
    videoBackground,
    halfBoxBackgroundColor,
    handleScroll,
  } = data;
  const { subheaderRef, headerRef, halfBoxRef } = useHeaderAnimation();

  const renderVideoBackground = renderWhenTrue(() => (
    <VideoBackground
      autoPlay
      muted
      loop
    >
      <source src={videoBackground?.localFile?.url} type="video/mp4" />
    </VideoBackground>
  ));
  
  return (
    <>
      <TopContentContainer>
        <HeadersBox>
          <HeaderContainer>
            <Header ref={headerRef}>{headerContent}</Header>
          </HeaderContainer>
          <Subheader>{subheaderContent}</Subheader>
        </HeadersBox>
        <LocalButton onClick={handleScroll}>{buttonLabel}</LocalButton>
      </TopContentContainer>
      <Container background={background?.localFile?.url}>
        {renderVideoBackground(!!videoBackground)}
        <InnerContainer>
          <Content>
            <HeadersBox>
              <HeaderContainer>
                <Header ref={headerRef}>{headerContent}</Header>
              </HeaderContainer>
              <SubHeaderContainer>
                <Subheader ref={subheaderRef}>{subheaderContent}</Subheader>
              </SubHeaderContainer>
            </HeadersBox>
            <LocalButton onClick={handleScroll}>{buttonLabel}</LocalButton>
          </Content>
          <HalfBox ref={halfBoxRef} backgroundColor={halfBoxBackgroundColor} />
        </InnerContainer>
      </Container>
    </>
  );
};
